import { createSlice } from '@reduxjs/toolkit'

export const addressSlice = createSlice({
  name: 'address',
  initialState: {
    address: null,
    open: false,
  },
  reducers: {
    setAddress: (state, action) => {
      state.address = action.payload
    },
    setOpen: (state, action) => {
      state.open = action.payload
    },
    setCountry: (state, action) => {
      state.address.country = action.payload
    },
  },
})

export const { setAddress, setOpen, setCountry } = addressSlice.actions

export default addressSlice.reducer
